import { DotGridPoint } from "@/app/types/illustrations/DotGridPoint";

export const DOT_GRID_TILE = 96;
export const DOT_GRID_RADIUS = 1;

const DOT_GRID_STEP = 24;
const DOT_GRID_CROSS_ARM = 4;
const DOT_GRID_CROSS_CENTER = DOT_GRID_TILE / 2 + DOT_GRID_STEP / 2;

const DOT_GRID_AXIS: number[] = Array.from(
  { length: DOT_GRID_TILE / DOT_GRID_STEP },
  (_, index) => index * DOT_GRID_STEP + DOT_GRID_STEP / 2,
);

export const DOT_GRID_POINTS: DotGridPoint[] = DOT_GRID_AXIS.flatMap((y) =>
  DOT_GRID_AXIS.map((x) => ({ x, y })),
).filter((point) => point.x !== DOT_GRID_CROSS_CENTER || point.y !== DOT_GRID_CROSS_CENTER);

export const DOT_GRID_CROSS_PATH = `M${DOT_GRID_CROSS_CENTER - DOT_GRID_CROSS_ARM} ${DOT_GRID_CROSS_CENTER}H${DOT_GRID_CROSS_CENTER + DOT_GRID_CROSS_ARM}M${DOT_GRID_CROSS_CENTER} ${DOT_GRID_CROSS_CENTER - DOT_GRID_CROSS_ARM}V${DOT_GRID_CROSS_CENTER + DOT_GRID_CROSS_ARM}`;
